"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PieChartIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "51",
  height: "51",
  viewBox: "0 0 51 51",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "prefix__a",
      d: "M0 0h2.308v2.308H0z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "prefix__c",
      d: "M0 0h44.795v44.796H0z"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(26.893 .017)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
        id: "prefix__b",
        fill: "#fff",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#prefix__a"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M1.154 2.308a1.154 1.154 0 110-2.307 1.154 1.154 0 010 2.308",
        fill: "#4CA94F",
        mask: "url(#prefix__b)",
        className: "svg-fill-primary"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M34.291 23.568a.9.9 0 01-.679-1.49l11.072-12.74a.9.9 0 111.358 1.181L34.971 23.26a.899.899 0 01-.68.31M40.005 23.568a.9.9 0 01-.683-1.486l7.596-8.865a.9.9 0 011.367 1.172l-7.596 8.865a.9.9 0 01-.684.314M45.363 23.245a.9.9 0 01-.68-1.491l3.694-4.249a.9.9 0 011.358 1.181l-3.692 4.249a.899.899 0 01-.68.31M28.047 23.568a.9.9 0 01-.682-1.487L41.267 5.927a.9.9 0 011.364 1.174L28.73 23.255a.898.898 0 01-.683.313M28.768 15.516a.9.9 0 01-.679-1.49l9.127-10.503a.9.9 0 011.359 1.181l-9.127 10.502a.899.899 0 01-.68.31M28.047 9.049a.9.9 0 01-.65-1.522l5.895-6.158a.9.9 0 011.3 1.244L28.696 8.77a.9.9 0 01-.65.278",
      fill: "#4CAA50",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(.555 5.674)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
        id: "prefix__d",
        fill: "#fff",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#prefix__c"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M21.498 1.819C10.556 2.293 1.8 11.341 1.8 22.397c0 11.358 9.24 20.598 20.598 20.598 11.056 0 20.105-8.756 20.578-19.697H22.398a.9.9 0 01-.9-.901V1.819zm.9 42.977C10.048 44.796 0 34.748 0 22.397 0 10.048 10.048 0 22.398 0a.9.9 0 01.9.9v20.597h20.597a.9.9 0 01.9.9c0 12.351-10.047 22.399-22.397 22.399z",
        fill: "#FFFFFF",
        mask: "url(#prefix__d)",
        className: "svg-fill-secondary"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M49.545 23.568H28.047a.9.9 0 01-.9-.9V5.171a.9.9 0 111.8 0v16.596h19.678c-.387-8.79-6.417-16.49-14.93-18.913a.9.9 0 11.494-1.73c9.57 2.722 16.256 11.582 16.256 21.544a.9.9 0 01-.9.9",
      fill: "#4CAA50",
      className: "svg-fill-primary"
    })]
  })]
});

PieChartIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(PieChartIcon);

exports.default = _default;